export const openPage = (mediaSrc, type) => {

  // default small size
  let features = 'width=200,height=200';

   // Adjust the initial size for YouTube and videos right away
   if (type === 'youtube' || type === 'video') {
    // Start with a window that is half the screen size for videos and YouTube links
    features = `width=${window.screen.width / 2},height=${window.screen.height / 2},resizable=yes`;
  }

  const popupWindow = window.open('', '_blank', features);

  if (type === 'image') {
    const image = new Image();
    image.onload = function() {
      popupWindow.resizeTo(this.width, this.height);
      popupWindow.document.title = mediaSrc;
      popupWindow.document.body.style.margin = '0';
      popupWindow.document.body.innerHTML = `<img src="${mediaSrc}" alt="Image Popup" style="width:100%; height:auto;">`;
    };
    image.src = mediaSrc;
  } else if (type === 'video') {
    popupWindow.document.title = mediaSrc;
    popupWindow.document.body.style.margin = '0';
    popupWindow.document.body.innerHTML = `
      <video controls autoplay style="width:100%; height:100%;">
        <source src="${mediaSrc}" type="video/mp4">
        Your browser does not support this video format.
      </video>`;
  } else if (type === 'youtube') {
      const videoId = mediaSrc.split('/').pop();
      popupWindow.document.title = 'YouTube Video';
      popupWindow.document.body.style.margin = '0';
      popupWindow.document.body.innerHTML = `
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  }
};  

export default openPage;

